// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__O6JMg","footer":"ModalUpdate_footer__sY0EO"};